import React from 'react'
import { useMutation } from '@tanstack/react-query'
import { currentQueryService } from 'utils/api/queries'

import { DateISO8601, HistoryCreateBody } from 'models'
import { useAuthenticatedUser } from 'contexts/UserContext'

import { useAlert } from 'contexts/AlertContext'
import { useGetIp } from './useGetIp'

const usePostReserveHistory = (
  vehicleNo: string,
  licensePlate: string,
  entityId: string,
  reservePriceBefore: number,
  reservePriceAfter: number,
) => {
  const { authenticatedUser, displayedEmail } = useAuthenticatedUser()
  const { data: ipAddress, isSuccess: isIpSuccess } = useGetIp()
  const { displayAlert } = useAlert()
  const userId = authenticatedUser.clientPrincipal?.userId as string

  const updateBody: HistoryCreateBody = {
    // USER
    userId,
    userIp: isIpSuccess ? (ipAddress as string) : 'Error recording Ip address',
    userDetails: displayedEmail,
    // ENTITY
    // VEHICLE
    vehicleNo,
    entityId,
    licensePlate,
    reservePriceBefore,
    reservePriceAfter,
    // OTHERS
    updateDateTime: new Date().toISOString() as unknown as DateISO8601,
  }

  const query = useMutation<unknown, Error>({
    mutationKey: ['usePostReserveHistory'],
    mutationFn: () => currentQueryService.postReserveHistory(updateBody),
  })

  React.useEffect(() => {
    if (query.isError) {
      displayAlert(
        query.error?.message ||
          'Error storing modification in history. Modification may still be valid',
        'error',
      )
    }
  }, [query.isError])

  return query
}

export { usePostReserveHistory }
